import React, { createContext, useContext } from "react";
import * as Yup from "yup";

const ValidationContext = createContext();

const ValidationProvider = ({ children }) => {
  // ---------- Standart Validasyon ----------
  const vs_standart = Yup.object().shape({
    name: Yup.string()
      .required("Please enter a name!")
      .min(2, "Name must be at least 2 characters!")
      .max(40, "Name can be up to 40 characters long!"),
    description: Yup.string()
      .required("Please enter a description!")
      .min(2, "Description must be at least 2 characters!")
      .max(200, "Description can be up to 200 characters long!"),
    status: Yup.string().required("Please choose a status!"),
  });

  // ---------- Action Modal Validasyonu ----------
  const vs_action = Yup.object().shape({
    name: Yup.string().trim().required("Lütfen bir aksiyon adı giriniz"),
    selectedSubActions: Yup.array()
      .min(1, "Lütfen bir aksiyon seçiniz")
      .required("Lütfen bir aksiyon seçiniz"),
  });

  // ---------- Customer Modal Validasyonu ----------
  
  // ValidationContext içindeki vs_customer örneği
const vs_customer = Yup.object().shape({
  fullName: Yup.string()
    .trim()
    .required("Lütfen isim giriniz")
    .min(2, "İsim en az 2 karakter olmalı")
    .max(250, "İsim en fazla 250 karakter olmalı"),

  phone1: Yup.string()
    .required("Telefon 1 gerekli")
    .matches(/^\d+$/, "Sadece rakam girebilirsiniz")
    .min(10, "Telefon en az 10 karakter olmalı")
    .max(11, "Telefon en fazla 11 karakter olmalı"),

  phone2: Yup.string()
    .matches(/^\d*$/, "Sadece rakam girebilirsiniz")
    .min(10, "Telefon en az 10 karakter olmalı")
    .max(11, "Telefon en fazla 11 karakter olmalı")
    .notRequired(),   // 🔹 Artık boş bırakılabilir

  tcNo: Yup.string()
    .matches(/^\d*$/, "Sadece rakam içerebilir")
    .when("customerType", (customerType, schema) =>
      customerType === "bireysel"   // 🔹 küçük harf ile eşleşecek
        ? schema
            .length(11, "T.C. Kimlik No 11 haneli olmalı")
            .required("T.C. Kimlik No gerekli")
        : schema.notRequired()
    ),

  vergiNo: Yup.string()
    .when("customerType", {
      is: "kurumsal",   
      then: (schema) =>
        schema
          .required("Vergi numarası gerekli")
          .min(2, "Vergi numarası en az 2 karakter olmalı"),
      otherwise: (schema) => schema.notRequired(),
    }),

  vergiDairesi: Yup.string()
    .when("customerType", {
      is: "kurumsal",
      then: (schema) =>
        schema
          .required("Vergi dairesi alanı gerekli")
          .min(2, "Vergi dairesi en az 2 karakter olmalı"),
      otherwise: (schema) => schema.notRequired(),
    }),

  city: Yup.string().required("Şehir gerekli"),
  district: Yup.string().required("İlçe gerekli"),

  address: Yup.string()
    .required("Adres gerekli")
    .min(2, "Adres en az 2 karakter olmalı")
    .max(250, "Adres en fazla 250 karakter olmalı"),
});

  // ---------- Offer Modal Validasyonu ----------
  
  // ---------- Personel Modal Validasyonu ----------
  const vs_personel = Yup.object().shape({
    fullName: Yup.string()
      .trim()
      .required("Lütfen isim giriniz")
      .min(2, "İsim en az 2 karakter olmalı")
      .max(250, "İsim en fazla 250 karakter olmalı"),
    email: Yup.string()
      .email("Geçerli bir e-posta giriniz")
      .required("E-posta gerekli"),
    password: Yup.string()
      .required("Şifre gerekli")
      .min(6, "Şifre en az 6 karakter olmalı"),
    position: Yup.string().required("Pozisyon gerekli"),
    company: Yup.string().required("Bayi bilgisi gerekli"),
    phone: Yup.string()
      .required("Telefon gerekli")
      .matches(/^\d+$/, "Sadece rakam girebilirsiniz")
      .min(10, "Telefon en az 10 karakter olmalı")
      .max(11, "Telefon en fazla 11 karakter olmalı"),
    prim: Yup.number()
      .typeError("Prim sayısal olmalı")
      .required("Prim gerekli")
      .min(0, "Prim negatif olamaz"),
    city: Yup.string().required("Şehir gerekli"),
    district: Yup.string().required("İlçe gerekli"),
    address: Yup.string()
      .required("Adres gerekli")
      .min(2, "Adres en az 2 karakter olmalı")
      .max(250, "Adres en fazla 250 karakter olmalı"),
    status: Yup.string().required("Durum gerekli"),
    workType: Yup.string().required("Mesai durumu gerekli"),
  });

  // ---------- Cash Modal Validasyonu ----------
 const vs_cash = Yup.object().shape({
  date: Yup.string().required("Lütfen tarih giriniz"),
  paymentType: Yup.string().required("Lütfen ödeme türü giriniz"),
  paymentDirection: Yup.string().required("Lütfen ödeme yönünü seçiniz"),
  paymentMethod: Yup.string().required("Lütfen ödeme şeklini seçiniz"),
  status: Yup.string().required("Lütfen durumu seçiniz"),
  realizationDate: Yup.string(),
  installment: Yup.string().required("Lütfen taksit/vade seçiniz"), // <- Eklendi
  amount: Yup.number()
    .required("Lütfen tutar giriniz")
    .min(0, "Tutar negatif olamaz"),
  description: Yup.string(),
});

  // ---------- Shelf Modal Validasyonu ----------
  const vs_shelf = Yup.object().shape({
    name: Yup.string()
      .trim()
      .required("Raf adı gerekli")
      .max(50, "Raf adı en fazla 50 karakter olmalı"),
    status: Yup.string().required("Durum seçimi zorunludur"),
    personelId: Yup.number()
      .nullable()
      .required("Personel seçimi zorunludur"),
  });


// ---------- Offer Modal Validasyonu ----------

const vs_offer = Yup.object().shape({
  plannedDate: Yup.date()
    .required("Planlanan teslim tarihi zorunludur")
    .min(new Date(), "Geçmiş tarih seçilemez"),
  selectedServices: Yup.array()
       .min(1, "En az bir servis seçmelisiniz")
       .of(
         Yup.object().shape({
           name: Yup.string().required("Servis adı zorunlu"),
           quantity: Yup.number().min(1).required("Adet zorunlu"),
           price: Yup.number().min(0).required("Fiyat zorunlu"),
         })
       ),
  note: Yup.string().max(250, "Not en fazla 250 karakter olmalı"), 
});


 // ---------- Warehouse (Depo) Modal Validasyonu ----------
   const vs_warehouse = Yup.object().shape({
    name: Yup.string().trim().required("Depo adı zorunludur").min(2, "Depo adı en az 2 karakter olmalıdır").max(100, "Depo adı en fazla 100 karakter olabilir"),
    location: Yup.string().trim().required("Lokasyon zorunludur").min(2, "Lokasyon en az 2 karakter olmalıdır").max(100, "Lokasyon en fazla 100 karakter olabilir"),
    status: Yup.string().trim().required("Durum seçimi zorunludur").oneOf(["Aktif", "Pasif"], "Geçersiz durum değeri"),
  });
  
const vs_service = Yup.object().shape({
  brand: Yup.string().trim().required("Marka gerekli").max(50, "Marka en fazla 50 karakter olabilir"),
  device: Yup.string().trim().required("Cihaz gerekli").max(50, "Cihaz en fazla 50 karakter olabilir"),
  deviceModel: Yup.string().trim().required("Model gerekli").max(50, "Model en fazla 50 karakter olabilir"),
  issue: Yup.string().trim().required("Arıza notu gerekli").max(500, "Arıza notu en fazla 500 karakter olabilir"),
  note: Yup.string().trim().max(250, "Ek not en fazla 250 karakter olabilir"),
  warranty: Yup.string().required("Garanti durumu gerekli").oneOf(["var", "yok"]),
  availableDate: Yup.string().required("Tarih gerekli"),
  availableStart: Yup.string().required("Başlangıç saati gerekli"),
  availableEnd: Yup.string().required("Bitiş saati gerekli"),
});
// ---------- Service Action Validasyonu ----------
  const vs_serviceAction = Yup.object().shape({
    subActionId: Yup.string().required("Yapılacak işlem seçimi zorunludur"),
    note: Yup.string().required("Açıklama zorunludur"),
    amount: Yup.number()
      .typeError("Tutar bir sayı olmalıdır")
      .required("Tutar zorunludur"),
    paymentDate: Yup.string().required("Ödeme tarihi zorunludur"),
    personnel: Yup.object()
      .nullable()
      .required("Personel seçimi zorunludur"),
    workDone: Yup.string().required("Yapılan işlemler zorunludur"),
    offer: Yup.number()
      .typeError("Teklif bir sayı olmalıdır")
      .required("Teklif zorunludur"),
    callTime: Yup.string().required("Arama saati seçimi zorunludur"),
    price: Yup.number()
      .typeError("Fiyat bir sayı olmalıdır")
      .required("Fiyat zorunludur"),
  });

  // ----------Brands ----------
 const vs_brand = Yup.object().shape({
  name: Yup.string()
    .required("Marka adı zorunludur")
    .min(2, "Marka adı en az 2 karakter olmalıdır")
    .max(50, "Marka adı en fazla 50 karakter olabilir"),
  description: Yup.string()
    .required("Açıklama zorunludur")
    .min(2, "Açıklama en az 2 karakter olmalıdır")
    .max(200, "Açıklama en fazla 200 karakter olabilir"),
  
});

 // ----------Devives----------
const vs_device = Yup.object().shape({
  brand: Yup.string().required("Marka zorunludur").min(2, "En az 2 karakter olmalı").max(50, "En fazla 50 karakter olabilir"),
  model: Yup.string().required("Model zorunludur").min(1, "En az 1 karakter olmalı").max(50, "En fazla 50 karakter olabilir"),
  description: Yup.string().required("Açıklama zorunludur").min(2, "En az 2 karakter olmalı").max(200, "En fazla 200 karakter olabilir"),
});


// ----------Vehicles ----------
const vs_vehicle = Yup.object().shape({
    brand: Yup.string().required("Marka zorunludur").min(2).max(50),
    model: Yup.string().required("Model zorunludur").min(1).max(50),
    plate: Yup.string()
      .required("Plaka zorunludur")
      .matches(/^[0-9A-Z]{2,10}$/, "Geçersiz plaka"),
    dealerName: Yup.string().required("Bayi seçimi zorunludur"),
    description: Yup.string().required("Açıklama zorunludur").min(2).max(200),
  });
// ----------Suppliers----------
const vs_supplier = Yup.object().shape({
    supplierName: Yup.string()
      .min(2, "En az 2 karakter olmalıdır")
      .required("Tedarikçi adı zorunludur"),
     dealerName: Yup.string().required("Bayi seçimi zorunludur"),
    status: Yup.string()
      .oneOf(["Aktif", "Pasif"], "Durum Aktif veya Pasif olmalıdır")
      .required("Durum zorunludur"),
  });
  // ----------Dealer---------
 const vs_dealer = Yup.object().shape({
    name: Yup.string()
      .min(2, "En az 2 karakter olmalıdır")
      .required("Bayi adı zorunludur"),
    status: Yup.string()
      .oneOf(["Aktif", "Pasif"], "Durum Aktif veya Pasif olmalıdır")
      .required("Durum zorunludur"),
  });
  const values = {
    vs_dealer,
    vs_supplier,
    vs_vehicle,
    vs_device,
    vs_brand,
    vs_serviceAction,
    vs_standart,
    vs_action,
    vs_customer,
    vs_offer,
    vs_cash,
    vs_personel,
    vs_shelf,
    vs_warehouse, 
    vs_offer,
    vs_service
  };
  return (
    <ValidationContext.Provider value={values}>
      {children}
    </ValidationContext.Provider>
  );
};

const useValidations = () => useContext(ValidationContext);

export { ValidationProvider, useValidations };
